









import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class Button extends Vue {
  click(e: Event) {
    this.$emit('click', e)
  }
}
